import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Home from "./pages/Home/index.tsx";
import Login from "./pages/Login/index.tsx";
import Register from "./pages/Register/index.tsx";
import Auth from "./pages/Auth/index.tsx";
import Dashboard from "./pages/Dashboard/index.tsx";
import ProtectedLayout from "./components/ProtectedLayout/index.tsx";
import Transactions from "./pages/Transactions/index.tsx";
import Subscriptions from "./pages/Subscriptions/index.tsx";
import Budgets from "./pages/Budgets/index.tsx";
import Loans from "./pages/Loans/index.tsx";
import Goals from "./pages/Goals/index.tsx";
import CalendarView from "./pages/CalendarView/index.tsx";
// Tailwind is configured in src/index.css; no separate App.css
import Friends from "./pages/Friends/index.tsx";
import Amortization from "./pages/Amortization/index.tsx";
import PricingPage from "./pages/Pricing/index.tsx";
import FeaturesPage from "./pages/Features/index.tsx";
import Settings from "./pages/Settings/index.tsx";
import Profile from "./pages/Profile/index.tsx";
import ForgotPassword from "./pages/ForgotPassword/index.tsx";
import Terms from "./pages/Terms/index.tsx";
import PaymentSuccess from "./pages/PaymentSuccess/index.tsx";
import PaymentCancel from "./pages/PaymentCancel/index.tsx";
import VerifyEmail from "./pages/VerifyEmail/index.tsx";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const raw = localStorage.getItem("user");
  const user = raw ? (() => { try { return JSON.parse(raw); } catch { return null; } })() : null;
  const authed = !!user?.access_token;
  if (!authed) return <Navigate to="/auth" replace />;

  const isVerified = user?.is_email_verified !== false;
  if (!isVerified && location.pathname !== "/verify-email") {
    return <Navigate to="/verify-email" replace />;
  }

  return children;
};

const PublicRoute = ({ children }) => children;

function App() {
  return (
    <div className="w-full h-full">
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route
            path="/auth"
            element={
              <PublicRoute>
                <Auth />
              </PublicRoute>
            }
          />
          {/* Backward compatibility redirects */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/"
            element={
              <PublicRoute>
                <Home />
              </PublicRoute>
            }
          />
          <Route
            path="/pricing"
            element={
              <PublicRoute>
                <PricingPage />
              </PublicRoute>
            }
          />
          <Route
            path="/features"
            element={
              <PublicRoute>
                <FeaturesPage />
              </PublicRoute>
            }
          />
          <Route
            path="/forgot-password"
            element={
              <PublicRoute>
                <ForgotPassword />
              </PublicRoute>
            }
          />
          <Route
            path="/terms"
            element={
              <PublicRoute>
                <Terms />
              </PublicRoute>
            }
          />
          <Route
            path="/verify-email"
            element={
              <PublicRoute>
                <VerifyEmail />
              </PublicRoute>
            }
          />
          <Route
            path="/payment/success"
            element={
              <PublicRoute>
                <PaymentSuccess />
              </PublicRoute>
            }
          />
          <Route
            path="/payment/cancel"
            element={
              <PublicRoute>
                <PaymentCancel />
              </PublicRoute>
            }
          />

          {/* Protected Routes with common layout */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <ProtectedLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/transactions" element={<Transactions />} />
            <Route path="/subscriptions" element={<Subscriptions />} />
            <Route path="/budgets" element={<Budgets />} />
            <Route path="/loans" element={<Loans />} />
            <Route path="/goals" element={<Goals />} />
            <Route path="/friends" element={<Friends />} />
            <Route path="/amortization" element={<Amortization />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/calendar" element={<CalendarView />} />
          </Route>
        </Routes>
      </Router>
    </div>

  );
}

export default App;

